"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fastFreshId = require("./fastFreshId");
const visitor = {
    Scope({ scope }, { opts: { reserved } }) {
        const shadows = Object.keys(scope.bindings)
            .filter(x => reserved.includes(x));
        for (const x of shadows) {
            const new_name = fastFreshId.fresh(x);
            scope.rename(x, new_name.name);
        }
    }
};
function default_1() {
    return { visitor: visitor };
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHlnaWVuZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3RzL2h5Z2llbmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSw2Q0FBNkM7QUFHN0MsTUFBTSxPQUFPLEdBQVk7SUFDdkIsS0FBSyxDQUFDLEVBQUUsS0FBSyxFQUF3QixFQUMvQixFQUFFLElBQUksRUFBRSxFQUFFLFFBQVEsRUFBRSxFQUFTO1FBQ2pDLE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQzthQUN4QyxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDckMsS0FBSyxNQUFNLENBQUMsSUFBSSxPQUFPLEVBQUU7WUFDdkIsTUFBTSxRQUFRLEdBQUcsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUN0QyxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7U0FDaEM7SUFDSCxDQUFDO0NBQ0YsQ0FBQztBQUVGO0lBQ0UsT0FBTyxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsQ0FBQztBQUM5QixDQUFDO0FBRkQsNEJBRUMifQ==


//////////////////
// WEBPACK FOOTER
// ../hygiene/dist/ts/hygiene.js
// module id = 788
// module chunks = 0